import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { DashboardStyle } from './DashboardStyle';

import Header from '../AppBarOrs/Header';
import { Copyright } from '../UI/CopyRight';

import { BrowserRouter as Router, Switch } from 'react-router-dom';
import withAuthentication from '../../../user/componet/session/withAuthentication';
import { ReactNotifications } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'


function Dashboard({ children, menu }) {

  const classes = DashboardStyle();

  return (
    <>
      <Router>
        <div className={classes.root}>
        <ReactNotifications/>
          <CssBaseline />
          <Header title={process.env.REACT_APP_TITLE} _menus={menu} />
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
              <Grid container spacing={3}>
                <Switch >
                  <>
                    {children}
                  </>
                </Switch>
              </Grid>
              <Box pt={4}>
                <Copyright />
              </Box>
            </Container>
          </main>
        </div>
      </Router>
    </>
  );
}

export default withAuthentication(Dashboard);
